import groq from 'groq';

import { SLUG } from '../common';

/* WARN: If you change this query, make sure to update MAX_POSSIBLE_SCORES */
export const searchBlogArticles = () => groq`
  *[
    _type == "timeline_article" &&
    !(_id in path("drafts.**"))
  ] | score(
      boost(title match $searchTerm, 3),
      boost(summary match $searchTerm, 2),
      pt::text(body) match $searchTerm
    ) {
      _type,
      ${SLUG},
      title,
      "image": heroImage,
      _score
    } | order(_score desc)[ _score > 0 ][0...5]
`;
